import React from 'react';
import { Row, Col } from 'antd';
import { SectionComponent } from './SectionComponent';

export function Sections() {
	return (
		<Row justify="start" gutter={[0, 0]}>
			<Col xs={24}>
				<SectionComponent />
			</Col>
		</Row>
	);
}
